module.exports = __webpack_public_path__ + "fonts/0f62160c/aboutme-glyphs.svg";